import React from 'react'

export const IconAddRole = (props={}) => {
	const { size=20, imgSize=20 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<path d="M10 0.770264L2.5 3.73943V10.05C2.50244 11.6586 2.92703 13.2384 3.73133 14.6315C4.53563 16.0246 5.69147 17.1822 7.08333 17.9886L10 19.672L12.9167 17.9882C14.3085 17.1819 15.4643 16.0243 16.2686 14.6313C17.0729 13.2383 17.4975 11.6586 17.5 10.05V3.73943L10 0.770264ZM16.25 10.05C16.2479 11.4393 15.8812 12.8037 15.1866 14.0067C14.492 15.2099 13.4937 16.2097 12.2917 16.9061L10 18.2288L7.70833 16.9057C6.50631 16.2092 5.50811 15.2096 4.81348 14.0066C4.11886 12.8035 3.75215 11.4392 3.75 10.05V4.58893L10 2.11468L16.25 4.58893V10.05Z" />
			<path d="M10.6782 7.00024V8.94191H12.6198V9.97005H10.6782V11.9117H9.65V9.97005H7.70833V8.94191H9.65V7.00024H10.6782Z" />
		</svg>
	</>
}
